import React, { ComponentProps, useContext } from 'react'
import { Dropdown } from 'shared/components/ui'
import { SettingsDropdownContext } from './context'

export default function SettingsOption(props: ComponentProps<typeof Dropdown.Option>) {
  const close = useContext(SettingsDropdownContext)

  return <Dropdown.Option {...props} />
}
